import { toSnakeHandle } from './paths';

/**
 * Maps legacy block-factory camelCase props to doodBlockConfig snake_case keys.
 * Top-level prop names are converted; nested object values are kept as-is.
 */
export function legacyPropsToBlockConfig<Config extends Record<string, unknown>>(
  props: object,
): Partial<Config> {
  const config: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(props)) {
    if (value === undefined) {
      continue;
    }
    config[toSnakeHandle(key)] = value;
  }

  return config as Partial<Config>;
}

/** Semantic alias for atom components — same camelCase → snake_case conversion. */
export const legacyPropsToAtomConfig = legacyPropsToBlockConfig;
